import React from "react";
import { Box, Typography } from "@mui/material";
import colors from "../styles/colors";
import MoveableImage from "../components/MoveableImage/MoveableImage";
import { contentBoxStyle, imageContainerStyle } from "../styles/commonStyles";

const Craftmanship: React.FC = () => {
  // Define image paths using PUBLIC_URL
  const Armreif2 = `${process.env.PUBLIC_URL}/schmuck/Armreif2_1.png`;
  const Armreif3 = `${process.env.PUBLIC_URL}/schmuck/Armreif3_1.png`;
  const Armreif4 = `${process.env.PUBLIC_URL}/schmuck/Armreif3.jpg`;
  const Armreif5 = `${process.env.PUBLIC_URL}/schmuck/Armreif4.jpg`;
  const Ring2 = `${process.env.PUBLIC_URL}/schmuck/Ring2_1.png`;
  const Ring3 = `${process.env.PUBLIC_URL}/schmuck/Ring3_1.png`;
  const Box3 = `${process.env.PUBLIC_URL}/schmuck/box3.png`;
  const Egg3 = `${process.env.PUBLIC_URL}/schmuck/egg3.png`;

  return (
    <Box id="content" sx={contentBoxStyle}>
      <Box
        id="text-container"
        sx={{
          maxWidth: "1564px",
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr", // 1 column on extra small screens
            sm: "1fr 1fr", // 2 columns on small screens (1:1 ratio)
            md: "2fr 2fr", // 3 columns on medium screens (1:2 ratio)
          },
          gap: "2rem",
          paddingTop: "10rem",
          paddingBottom: "5rem",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            backgroundColor: "white",
            wordBreak: "break-word",
            borderRadius: "0px 0px 0px 0px",
            boxShadow: "2px 2px 4px rgba(200, 130, 173, 0.5)",
          }}
        >
          <Typography
            variant="h1"
            sx={{
              color: colors.filterColors[4],
              margin: "1rem",
            }}
          >
            Craftsmanship
          </Typography>
        </Box>
        <Box
          sx={{
            color: "white",
            borderRadius: "50px 0px 50px 0px",
            backgroundColor: colors.filterColors[4],
          }}
        >
          <Typography variant="body1" margin="1.5rem 1.8rem">
            <p>
              My journey in design began with my apprenticeship as a goldsmith,
              where I honed my skills working with traditional tools to craft
              silver jewelry — designing pieces like rings, necklaces, and
              earrings.
            </p>
            <p>
              This hands-on experience taught me the precision and patience
              required to transform raw materials into something meaningful.
              Later, in my studies in Metal and Jewelry Design, I expanded my
              creativity by incorporating digital tools like Blender to create
              intricate 3D models and print them.
            </p>
            <p>
              This blend of traditional craftsmanship and modern technology laid
              the foundation for my current approach, whether it's in design,
              music, or any creative process, always focused on mastering complex
              tools to shape and refine my work.
            </p>
          </Typography>
        </Box>
      </Box>
      <Box id="image-container" sx={imageContainerStyle}>
        <MoveableImage
          src={Armreif2}
          alt="Image of a bangle made in colored Plexiglass and sandblasted."
          headline="The Gear"
          description="Bangle - Colored Plexiglass - Sandblasted"
        />
        <MoveableImage
          src={Armreif3}
          alt="Image of a bangle made in silver and transparent Plexiglass."
          headline="The Gear"
          description="Bangle - Silver - Transparent Plexiglass - Sandblasted"
        />
        <MoveableImage
          src={Box3}
          alt="Image of a necklace made in gold and resin."
          headline="The Box"
          description="Necklace - Gold - Resin"
        />
        <MoveableImage
          src={Egg3}
          alt="Image of a necklace made in oxidized silver and resin."
          headline="The Egg"
          description="Necklace - Oxidized Silver - Resin"
        />
        <MoveableImage
          src={Ring2}
          alt="Image of a ring made in silver."
          headline="Cutlings"
          description="Ring - Silver"
        />
        <MoveableImage
          src={Ring3}
          alt="Image of a ring made in silver, Swarovski and ebony."
          headline="Cutlings"
          description="Ring - Silver - Swarovski - Ebony"
        />

        <MoveableImage
          src={Armreif4}
          alt="Image of a cuff bracelet made in silver and oxidized."
          headline="Cuff bracelet"
          description="Silver - Chased - Oxidized"
        />
        <MoveableImage
          src={Armreif5}
          alt="Image of a cuff bracelet made in silver and oxidized."
          headline="Cuff bracelet"
          description="Silver - Chased - Oxidized"
        />
        

      </Box>
    </Box>
  );
};

export default Craftmanship;
